/**
 * 工具类
 */
import CryptoJS from 'crypto-js'
export default {
  // 加密
  encrypt(word, keyStr) {
    keyStr = keyStr || '1q2w3e4r%T^Y&U*I'
    var key = CryptoJS.enc.Utf8.parse(keyStr)
    var srcs = CryptoJS.enc.Utf8.parse(word)
    var encrypted = CryptoJS.AES.encrypt(srcs, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    })
    return encrypted.toString()
  },
  // 解密
  decrypt(word, keyStr) {
    keyStr = keyStr || '1q2w3e4r%T^Y&U*I'
    var key = CryptoJS.enc.Utf8.parse(keyStr)
    var decrypt = CryptoJS.AES.decrypt(word, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    })
    return CryptoJS.enc.Utf8.stringify(decrypt).toString()
  },
}

/**
 * 深拷贝
 * @param {Object} source
 * @returns {Object}
 */
export function deepClone(source) {
  if (source == null) {
    return null
  }
  if (typeof source !== 'object') {
    throw new Error('error arguments', 'deepClone')
  }
  const targetObj = source.constructor === Array ? [] : {}
  Object.keys(source).forEach(keys => {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = deepClone(source[keys])
    } else {
      targetObj[keys] = source[keys]
    }
  })
  return targetObj
}

/**
 * 使用message对象封装消息
 * @returns message
 */
export function message() {
  var message = {
    time: 0,
    title: document.title,
    timer: null,
    // 显示新消息提示
    show: function() {
      var title = message.title.replace('【　　　】', '').replace('【新消息】', '')
      // 定时器，设置消息切换频率闪烁效果就此产生
      message.timer = setTimeout(function() {
        message.time++
        message.show()
        if (message.time % 2 === 0) {
          document.title = '【新消息】' + title
        } else {
          document.title = '【　　　】' + title
        }
      }, 600)
      return [message.timer, message.title]
    },
    // 取消新消息提示
    clear: function() {
      clearTimeout(message.timer)
      document.title = message.title
    },
  }
  return message
}
